import { post, postJson, deleteApi, put, get, imagePost } from './axios3'

import { putOne } from './axios2'

const RESOURCE_BASE_PATH = '/paradiseAndTaskCommon';

const RESOURCE_BASE_PATH2 = '/pointsExchange';

const RESOURCE_BASE_PATH3 = '/image';

const RESOURCE_BASE_PATH4 = '/PointActivityAnalyticController';

const RESOURCE_BASE_PATH5 = '/bigTurntableDraw';

// 分页获取活动列表(积分任务和积分乐园)
export const taskList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

// 获取活动域名
export const prefixurl = p => get(`${RESOURCE_BASE_PATH}/prefixurl`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)  
export const exchangeActivityList = p => postJson(`${RESOURCE_BASE_PATH2}/exchangeActivityList`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const setActivityList = p => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 删除礼品兑换活动列表(兑换优惠券和兑换实物)
export const deleteActivityList = id => deleteApi(`${RESOURCE_BASE_PATH2}/${id}`);

// 查询详情
export const inquireActivity = id => get(`${RESOURCE_BASE_PATH2}/${id}`);

// 修改详情
export const changeActivity = p => put(`${RESOURCE_BASE_PATH2}`, p);

// 上架下架礼品兑换
export const updateActivityList = p => put(`${RESOURCE_BASE_PATH2}/status/${p.id}?status=${p.status}`);

// 上传图片
export const uploadpic = p => imagePost(`${RESOURCE_BASE_PATH3}/upload`, p);

//标记发货
export const changeStatus = id => post(`${RESOURCE_BASE_PATH4}/markDeliveryStatus?id=${id}`);

//大转盘抽奖
export const bigTurntableDraw = p => postJson(`${RESOURCE_BASE_PATH5}`, p);

//修改大转盘抽奖
export const modifyBigTurn = p => putOne(`${RESOURCE_BASE_PATH5}`, p);

//大转盘抽奖详情
export const getbigTurn = id => get(`${RESOURCE_BASE_PATH5}/${id}`);